import React, { useRef } from "react";
import DropzoneComponent from "react-dropzone-component";
import "dropzone/dist/min/dropzone.min.css";

const BannerImageUpload = ({ onFileUpload,setFileError=false }) => {

  const dropzoneRef = useRef(null);

  const MAX_FILE_SIZE = 5 * 1024 * 1024; 

  const componentConfig = {
    postUrl: "no-url",
  };

  const djsConfig = {
    maxFiles: 1,
    acceptedFiles: "image/jpeg,image/jpg,image/png",
    autoProcessQueue: false,
    addRemoveLinks: true,
    dictDefaultMessage: "Drag & drop a file here or click to select",
    dictRemoveFile: "Remove",
  };

  const eventHandlers = {
    addedfile: (file) => {
      if (file.size > MAX_FILE_SIZE) {
        setFileError("Maximum file size allowed: 5MB");
        // alert("Maximum file size allowed: 5MB");
        dropzoneRef.current.dropzone.removeFile(file);
        return;
      }else{
        setFileError("");
      }

      if (dropzoneRef.current && dropzoneRef.current.dropzone.files.length > 1) {
        dropzoneRef.current.dropzone.removeFile(dropzoneRef.current.dropzone.files[0]);
      }
      
      onFileUpload(file);
    },
    removedfile: () => {
      onFileUpload(null);
    },
  };

  return (
    <DropzoneComponent
      ref={dropzoneRef}
      config={componentConfig}
      eventHandlers={eventHandlers}
      djsConfig={djsConfig}
    />
  );
};

export default BannerImageUpload;
